import { useState } from "react";
import { UseAuth } from "./AuthContext/AuthContext";
import { Usedata } from "./Context/Allcontext";

function Sinup(){
    const {setAcsingup,Acsingup , ActivLogin , ActiveSinup} = Usedata()
    const {sinup, crentuser, adddate_user} = UseAuth()
    const [email,setemail] = useState()
    const [password, setpassword] = useState()
    const [name, setname] = useState()
    const [image, setimage] = useState("/images/115.webp")
    const [Akoon, setAkoon] = useState("Shakhsi")
    if(crentuser && crentuser){
        setAcsingup(false)
    }
    // SAMAYNTA AKOOON
    const Handalelogin = async (e) => {
        e.preventDefault()
        try{
            const response = await  sinup(email,password)
            await adddate_user(name,image,Akoon ,response.user.uid)
        } catch (erro){
            console.log(erro)
        }
    }
    return(
    <>
    {Acsingup && (
        <section className="overley sinup active">
        <div className="haye">
            {/* <!--sinup--> */}
            <div className="model_sinup singup">
                <form method="POST" onSubmit={Handalelogin}>
                <div className="close_oplsulet" onClick={ActiveSinup}><i className="fa-solid fa-circle-xmark"></i></div>
                    <h2>Is Diwaan Gali</h2>
                    <input type="text" name="name" placeholder="Qor Magacaaga" spellCheck="false" 
                    onInput={(e => setname(e.target.value))}
                    value={name}
                    />
                    <input type="email" name="email" placeholder="Qor E-mailkaaga"
                        onInput={(e => setemail(e.target.value))}
                        value={email}
                    />
                    <input type="password" name="password" placeholder="Qor Passwor-kaaga" 
                    onInput={(e => setpassword(e.target.value))}
                    value={password}
                    />
                    <div className="count_err">
                        <p className="err"></p>
                    </div>
                    
                    <button type="submit">Diwaan Gali</button>
                    <a href="#" onClick={ActivLogin}>
                        Gal Akoon Hore
                    </a>
                </form>
            </div>
        </div>
    </section>
    )}
</>
)
}


export default Sinup